export const TEST_COOKIE = 'testcookie';
export const COOKIE_DISABLED_MSG =
  'Las cookies deben estar habilitadas en su navegador.';
